import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    side: false
  },
  getters: {
    getStateSide: function (state) {
      return state.side
    }
  },
  mutations: {
    sideEna (state) {
      state.side = true
    },
    sideDis (state) {
      state.side = false
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js